import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchConfiguredCompanyList } from '../actions/companyActions'

const useFetchingCompanyDetails = (id) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchConfiguredCompanyList())
  }, [dispatch])
}

export default useFetchingCompanyDetails
